import reClick from './reClick'

/**
 * 导出指令方法：v-xxx
 * @methods reClick 防止重复点击，用法：v-reClick
 */
export function directive(app) {
    //连续点击指令 v-reClick默认1秒不能连续点击,可自定义v-reClick="1000"
    app.directive('reClick', reClick)
}